<template>
  <div class="container-fluid" style="overflow-y: hidden">
    <div class="row" style="margin-bottom: 5px">
      <div class="col">
      </div>
    </div>

    <div class="row" style="height:100%;">
      <div class="col-12" style="height:100%;">
        <b-table
          class="textMiddle"
          style="height: 100%;"
          small
          hover
          bordered
          show-empty
          responsive
          head-variant="light"
          selectable
          select-mode="single"
          :items="limits"
          :fields="headers"
          v-bind:emptyText="$store.state.localization.data.common.table.noData"
          @row-clicked="itemClicked"
          v-bind:sticky-header="clientHeight"
        >
          <template #cell(fuelDepo)="data">
            {{ formatFuelDepo(data.item.fuelDepoId) }}
          </template>
          <template #cell(driver)="data">
            {{ formatDriver(data.item) }}
          </template>
          <template #cell(startTime)="data">
            {{ formatTime(data.item.startTime) }}
          </template>
          <template #cell(endTime)="data">
            {{ formatTime(data.item.endTime) }}
          </template>
          <template v-slot:empty="scope">
            <div class="row justify-content-md-center">
              <h5>{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template>
            <span class="text-success"></span>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { utilsService } from "../../../../services";

export default {
  name: "ListLimitsPage",
  props: {
    users: Array,
    limits: Array,
    fuelDepos: Array,
    drivers: Array,
  },
  data() {
    return {
      currentSelectedItem: null
    };
  },
  computed: {
    headers() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.azk.limits
          .tableColumns) {
            if (
              key == "id" ||
              key == "fuelDepo" ||
              key == "driver" ||
              key == "limitCurrent" ||
              key == "startTime" ||
              key == "endTime"
            ) {
              headers.push({
                key: key,
                label:
                  this.$store.state.localization.data.mainPage.azk.limits.tableColumns[
                    key
                  ],
                sortable: true,
                thClass: "textMiddle",
              });
            }
        }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 140;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
  },
  methods: {
    itemClicked(row) {
      this.currentSelectedItem = row;
    },
    formatFuelDepo(fuelDepoId) {
      for (let i = 0; i < this.fuelDepos.length; i++) {
        if (
          this.fuelDepos[i].id == fuelDepoId
        ) {
          return this.fuelDepos[i].name;
        }
      }

      return "";
    },
    formatDriver(limit) {
      for (let i = 0; i < this.drivers.length; i++) {
        if (
          this.drivers[i].clientId == limit.clientId && this.drivers[i].driverId == limit.driverId
        ) {
          return `${this.drivers[i].lastName} ${this.drivers[i].firstName} ${this.drivers[i].patronymic} `;
        }
      }

      return "";
    },
    formatTime(time) {
        if (time) {
            return utilsService.formatDateTime(new Date(time * 1000), utilsService.DATE_TIME_FORMAT);
        } else {
            return "";
        }
    }
  },
};
</script>
